module.exports = __webpack_public_path__ + "img/home-title2.cb349236.png";